import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { of } from 'rxjs';
import { environment } from 'src/environments/environment';
import { catchError } from 'rxjs/operators';

export interface Email {
  id: number;
  senderEmail: '';
  receiverEmails: '';
  bodyText: '';
  attachmentUrls: '';
  organizationId: '';
  createdOn: '';
  modifiedOn: '';
  createdBy: '';
  modifiedBy: '';
  status: '';
}

@Injectable({
  providedIn: 'root',
})
export class EmailService {
  private apiUrl = environment.apiUrl;
  constructor(private http: HttpClient) {}
  getEmails() {
    return this.http.get<any[]>(`${this.apiUrl}email_list`).pipe(
      catchError((err: HttpErrorResponse) => {
        console.error('Failed to load emails', err);
        return of([]);
      }),
    );
  }

  sendEmail(emailData: any) {
    return this.http.post(`${this.apiUrl}send_email`, emailData).pipe(
      catchError((err: HttpErrorResponse) => {
        console.error('Failed to send email', err);
        return of(null); // or return a specific error value
      }),
    );
  }

  getSentEmails() {
    return this.http.get<any[]>(`${this.apiUrl}sent_email`).pipe(
      catchError((err: HttpErrorResponse) => {
        console.error('Failed to load sent emails', err);
        return of([]);
      }),
    );
  }
}
